module.exports = __webpack_public_path__ + "static/img/tlb1.b033258.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/geren/newqietu/mgnew/tlb1.png
// module id = S2ZS
// module chunks = 36